import React, { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { usePlyxAuth } from "@/context/PlyxAuthContext";

/**
 * Decides what visiting bare /plyx shows.
 *
 * Per founder direction (Jun 2026): every visitor — signed-in or not —
 * gets dropped straight into the swipeable feed. With the catalogue
 * still small, the most powerful thing a stranger can do on plyx.co.uk
 * is start watching immediately; the marketing landing was an extra
 * tap that lost intent. Sign-in CTAs are already overlaid on every
 * card so guests still know how to join.
 */
const PlyxRoot = () => {
  const { loading } = usePlyxAuth();
  useEffect(() => {
    document.title = "Plyx — Where moments become movements";
  }, []);
  if (loading) return null; // PlyxAuthProvider's brief hydration window
  return <Navigate to="/plyx/feed" replace />;
};

export default PlyxRoot;
